import React, { useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Modal, IconButton, Text } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';

import { getStepBaseModalLayoutStyles } from './styles/step-base-modal-layout-styles';
import { StepModalFooter } from './step-base-modal-footer';

export function StepBaseModalLayout(props) {
  const {
    modalClassName,
    modalStyles,
    isLoading,

    onCancelClick,
    onPreviousClick,
    onNextClick,
    skippingLinkTitle,
    onSkippingLinkClick,

    nextButtonText,
    previousButtonText,
    title,
    stepProgressContent,

    isCloseDisabled,
    isPreviousDisabled,

    children,
  } = props;
  const classes = useDefaultStyles(getStepBaseModalLayoutStyles);
  const i18n = useContext(I18nContext);

  const [isModalOpen, setShowModal] = useState(true);
  const onCloseClick = useCallback(() => {
    onCancelClick();
    setShowModal(false);
  }, [onCancelClick]);

  return (
    <Modal
      isOpen={isModalOpen}
      onDismiss={onCloseClick}
      isBlocking
      className={classNames('step-base-modal', modalClassName)}
      containerClassName={classNames('step-base-modal-container', classes.modalContainer)}
      styles={modalStyles}
    >
      <UiBlocker
        blocking={isLoading}
        loadingText={i18n.getString(_TL_('Loading...'))}
      >
        <div className={classNames('step-modal-container', classes.stepModalContainer)}>
          <div className={classNames('step-base-modal-header', classes.stepModalHeader)}>
            {
              title &&
              <Text
                block
                variant="xLarge"
                className="modal-title"
              >
                {title}
              </Text>
            }
            <IconButton
              className="modal-cancel"
              iconProps={{ iconName: 'Cancel' }}
              ariaLabel={i18n.getString(_TL_('Cancel'))}
              onClick={onCloseClick}
              disabled={isCloseDisabled}
            />
          </div>
          <div className={classes.stepModalContentContainer}>
            <div className={classNames('step-base-modal-content', classes.stepContentContainer)}>
              {children}
            </div>
            <StepModalFooter
              onPreviousClick={onPreviousClick}
              onNextClick={onNextClick}
              onSkippingLinkClick={onSkippingLinkClick}
              skippingLinkTitle={skippingLinkTitle}
              previousButtonText={previousButtonText}
              nextButtonText={nextButtonText}
              stepProgressContent={stepProgressContent}
              isPreviousDisabled={isPreviousDisabled}
            />
          </div>
        </div>
      </UiBlocker>
    </Modal>
  );
}

StepBaseModalLayout.propTypes = {
  modalClassName: PropTypes.string,
  modalStyles: PropTypes.shape({}),
  isLoading: PropTypes.bool,

  onCancelClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
  skippingLinkTitle: PropTypes.string,
  onSkippingLinkClick: PropTypes.func,

  title: PropTypes.string,
  stepProgressContent: PropTypes.string,
  nextButtonText: PropTypes.string,
  previousButtonText: PropTypes.string,
  isCloseDisabled: PropTypes.bool,
  isPreviousDisabled: PropTypes.bool,

  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

StepBaseModalLayout.defaultProps = {
  modalClassName: '',
  modalStyles: null,
  isLoading: false,

  onNextClick: null,
  onPreviousClick: null,
  skippingLinkTitle: null,
  onSkippingLinkClick: null,
  onCancelClick: _.noop,

  nextButtonText: null,
  previousButtonText: null,

  children: null,
  title: null,
  stepProgressContent: null,

  isCloseDisabled: false,
  isPreviousDisabled: false,
};
